var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['share-button', _vm.color, _vm.icon]})
}
var staticRenderFns = []

export { render, staticRenderFns }